import {
  CancelOrder,
  GetHistoryOrderForm,
  GetHistoryOrderList,
  GetMarginOpenOrderList,
  GetMarginTradeLast24HList,
  GetSpotOpenOrderList,
  GetSpotTradeLast24HList,
  GetTradeAmountMax,
  GetTradeForm,
  GetTradeInitial,
  GetTradeList,
} from "./api";

import http from "config/http";

const tradeApi = {
  getTradeInitial: async ({ coinId, coinMasterId, sideId, walletTypeId }) =>
    await http.get(
      GetTradeInitial({
        coinId,
        coinMasterId,
        sideId,
        walletTypeId,
      })
    ),

  getTradeAmountMax: async ({ coinId, coinMasterId, sideId, walletTypeId }) =>
    await http.get(
      GetTradeAmountMax({
        coinId,
        coinMasterId,
        sideId,
        walletTypeId,
      })
    ),

  getSpotOpenOrderList: async (body) =>
    await http.get(GetSpotOpenOrderList(body)),

  getMarginOpenOrderList: async (body) =>
    await http.get(GetMarginOpenOrderList(body)),

  getSpotTradeLast24HList: async () => await http.get(GetSpotTradeLast24HList),

  getMarginTradeLast24HList: async () =>
    await http.get(GetMarginTradeLast24HList),

  cancelOrder: async ({ orderId }) => await http.post(CancelOrder, { orderId }),

  getTradeForm: async () => await http.get(GetTradeForm),

  getHistoryOrderForm: async () => await http.get(GetHistoryOrderForm),

  getHistoryOrderList: async ({
    coinSourceId,
    coinDestinationId,
    sideId,
    typeId,
    walletTypeId,
    startDate,
    endDate,
    pageNumber,
    pageSize,
  }) =>
    await http.get(
      GetHistoryOrderList({
        coinSourceId,
        coinDestinationId,
        sideId,
        typeId,
        walletTypeId,
        startDate,
        endDate,
        pageNumber,
        pageSize,
      })
    ),

  getTradeList: async ({
    coinSourceId,
    coinDestinationId,
    sideId,
    typeId,
    walletTypeId,
    startDate,
    endDate,
    pageNumber,
    pageSize,
  }) =>
    await http.get(
      GetTradeList({
        coinSourceId,
        coinDestinationId,
        sideId,
        typeId,
        walletTypeId,
        startDate,
        endDate,
        pageNumber,
        pageSize,
      })
    ),
};

export default tradeApi;
